/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { CampaignRequestToJSON, CampaignResponseFromJSON, PagedResponseOfCampaignListEntryFromJSON, } from '../models';
/**
 *
 */
var CampaignRestControllerApi = /** @class */ (function (_super) {
    __extends(CampaignRestControllerApi, _super);
    function CampaignRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new campaign <p> \'Permission#CREATE_CAMPAIGN\' is required to access to this endpoint
     * Create a new campaign <p> \'Permission#CREATE_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignRestControllerApi.prototype.createCampaignRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.campaignRequest === null || requestParameters.campaignRequest === undefined) {
                            throw new runtime.RequiredError('campaignRequest', 'Required parameter requestParameters.campaignRequest was null or undefined when calling createCampaign.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/campaigns",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CampaignRequestToJSON(requestParameters.campaignRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CampaignResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new campaign <p> \'Permission#CREATE_CAMPAIGN\' is required to access to this endpoint
     * Create a new campaign <p> \'Permission#CREATE_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignRestControllerApi.prototype.createCampaign = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createCampaignRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete campaign <p> \'Permission#DELETE_CAMPAIGN\' is required to access to this endpoint
     * Delete campaign <p> \'Permission#DELETE_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignRestControllerApi.prototype.deleteCampaignRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                            throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling deleteCampaign.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/campaigns/{campaignId}".replace("{".concat("campaignId", "}"), encodeURIComponent(String(requestParameters.campaignId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete campaign <p> \'Permission#DELETE_CAMPAIGN\' is required to access to this endpoint
     * Delete campaign <p> \'Permission#DELETE_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignRestControllerApi.prototype.deleteCampaign = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteCampaignRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get campaign details <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     * Get campaign details <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignRestControllerApi.prototype.getCampaignRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                            throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling getCampaign.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/campaigns/{campaignId}".replace("{".concat("campaignId", "}"), encodeURIComponent(String(requestParameters.campaignId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CampaignResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get campaign details <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     * Get campaign details <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignRestControllerApi.prototype.getCampaign = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCampaignRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List campaigns using pagination <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     * List campaigns using pagination <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignRestControllerApi.prototype.listCampaignsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/campaigns",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfCampaignListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List campaigns using pagination <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     * List campaigns using pagination <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignRestControllerApi.prototype.listCampaigns = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listCampaignsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Patch campaign (partial update). The patch request do not unset any value by setting null on a certain field. To unset any value use (PUT) update method. <p> \'Permission#UPDATE_CAMPAIGN\' is required to access to this endpoint. A campaign may update only itself.
     * Patch campaign (partial update).
     */
    CampaignRestControllerApi.prototype.patchCampaignRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                            throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling patchCampaign.');
                        }
                        if (requestParameters.campaignRequest === null || requestParameters.campaignRequest === undefined) {
                            throw new runtime.RequiredError('campaignRequest', 'Required parameter requestParameters.campaignRequest was null or undefined when calling patchCampaign.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/campaigns/{campaignId}".replace("{".concat("campaignId", "}"), encodeURIComponent(String(requestParameters.campaignId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CampaignRequestToJSON(requestParameters.campaignRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CampaignResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Patch campaign (partial update). The patch request do not unset any value by setting null on a certain field. To unset any value use (PUT) update method. <p> \'Permission#UPDATE_CAMPAIGN\' is required to access to this endpoint. A campaign may update only itself.
     * Patch campaign (partial update).
     */
    CampaignRestControllerApi.prototype.patchCampaign = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchCampaignRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update campaign <p> \'Permission#UPDATE_CAMPAIGN\' is required to access to this endpoint
     * Update campaign <p> \'Permission#UPDATE_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignRestControllerApi.prototype.updateCampaignRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                            throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling updateCampaign.');
                        }
                        if (requestParameters.campaignRequest === null || requestParameters.campaignRequest === undefined) {
                            throw new runtime.RequiredError('campaignRequest', 'Required parameter requestParameters.campaignRequest was null or undefined when calling updateCampaign.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/campaigns/{campaignId}".replace("{".concat("campaignId", "}"), encodeURIComponent(String(requestParameters.campaignId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CampaignRequestToJSON(requestParameters.campaignRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CampaignResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update campaign <p> \'Permission#UPDATE_CAMPAIGN\' is required to access to this endpoint
     * Update campaign <p> \'Permission#UPDATE_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignRestControllerApi.prototype.updateCampaign = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateCampaignRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return CampaignRestControllerApi;
}(runtime.BaseAPI));
export { CampaignRestControllerApi };
